import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    pointerEvents: 'none',

    '& .comment': {
      '&-content': {
        padding: theme.spacing(2),
        maxWidth: theme.spacing(36),
      },
      '&-title': {
        display: 'flex',
        marginBottom: theme.spacing(1),
        color: theme.palette.text.hint,
      },
    },
  },
}));

export default styles;
